'use strict';

var dateFns = require('date-fns');
var parsers = require('../parsers.cjs');

const parseISOTimeIntervalToDateInterval = (unorderedInterval) => {
  const start = parsers.isoTimePartToDate(unorderedInterval.start);
  const endCandidate = parsers.isoTimePartToDate(unorderedInterval.end);
  const isPositiveDuration = dateFns.isAfter(endCandidate, start);
  const end = isPositiveDuration ? endCandidate : dateFns.addDays(endCandidate, 1);
  return { start, end };
};

module.exports = parseISOTimeIntervalToDateInterval;
//# sourceMappingURL=parseISOTimeIntervalToDateInterval.cjs.map
